<template>
  <section class="page-wrapper">
    <div class="error-content">
      <div class="flex-column align-center">
        <info-icon size="4.0x" class="info-circle small-buffer" />
        <h3 class="small-buffer">Payment Network is not active</h3>
      </div>
      <p class="small-buffer">
        Please contact your medical practice. They have requested a payment that
        you might owe, however this network is decommissioned.
      </p>
    </div>
  </section>
</template>

<script>
  import { InfoIcon } from "vue-feather-icons";

  export default {
    name: "UpdoxCannotProcessPayments",
    components: { InfoIcon },
    props: {
      errorDetails: {
        type: Object,
        required: false,
      },
    },
    computed: {
      error: function () {
        return console.error("UpdoxCannotProcessPayments called");
      },
    },
    methods: {},
  };
</script>
<style lang="scss">
  .info-circle {
    color: blue;
  }
  .strong-highlight {
    background-color: yellow;
  }
  .small-buffer {
    margin-bottom: 5px;
  }
</style>
